(function applySwatchOnceReady() {
  const checkAndApply = () => {
    const swatches = window.dolfin?.variantSwatches;
    const button = document.querySelector('.color-picker button');

    if (!Array.isArray(swatches) || !button) {
      requestAnimationFrame(checkAndApply);
      return;
    }

    const valid = swatches.find(v =>
      v.swatch &&
      v.swatch !== "null" &&
      v.swatch.trim() !== "" &&
      !/informational/i.test(v.color || "")
    );

    if (valid) {
      button.style.backgroundImage = `url(${valid.swatch})`;
      button.style.backgroundSize = 'cover';
      button.style.backgroundRepeat = 'no-repeat';
      button.style.backgroundPosition = 'center';
    }
  };

  requestAnimationFrame(checkAndApply);
})();
